module.exports = __webpack_public_path__ + "static/img/2.150edab5.png";